import React from 'react';

export class RemoteAgentPresenceIcon extends React.Component<RemoteAgentPresenceIcon.Props, {}> {

  public static displayName = 'RemoteAgentPresenceIcon';

  public static element = React.createFactory(RemoteAgentPresenceIcon);

  public render() {
    return React.createElement('span', {
      className: this.getClassNames(),
      title: this.getStateText(),
    });
  }

  private getClassNames(): string {
    switch (this.props.currentState) {
      case 'CONNECTED':
        return 'tb-remote-agent-presence-icon tb-remote-agent-presence-connected';

      case 'THROTTLED':
        return 'tb-remote-agent-presence-icon tb-remote-agent-presence-warning';

      case 'DISCONNECTED':
      case 'NOT_IN_SERVICE_MODE':
      case 'NOT_RESPONSIVE':
      case 'NEEDS_UPGRADE':
        return 'tb-remote-agent-presence-icon tb-remote-agent-presence-not-connected';

      // The default style takes up the same amount of space but otherwise does not appear
      default:
        return 'tb-remote-agent-presence-icon';
    }
  }

  private getStateText(): string {
    switch (this.props.currentState) {
      case 'CONNECTED':           return this.props.stateTextStrings.stateTextConnected;
      case 'NOT_RESPONSIVE':      return this.props.stateTextStrings.stateTextNotResponsive;
      case 'NEEDS_UPGRADE':       return this.props.stateTextStrings.stateTextNeedsUpgrade;
      case 'THROTTLED':           return this.props.stateTextStrings.stateTextThrottled;
      case 'DISCONNECTED':        return this.props.stateTextStrings.stateTextNotConnected;
      case 'NOT_IN_SERVICE_MODE': return this.props.stateTextStrings.stateTextNotInServiceMode;
      default:  return null;
    }
  }
}

export module RemoteAgentPresenceIcon {

  export interface StateTextStrings {
    stateTextConnected: string;
    stateTextNotConnected: string;
    stateTextNotInServiceMode: string;
    stateTextNotResponsive: string;
    stateTextNeedsUpgrade: string;
    stateTextThrottled: string;
  }

  export interface Props {
    currentState: string;
    currentStateString: string;
    stateTextStrings: StateTextStrings;
  }
}
